import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";

const CosmeticCategoryFilter = ({ subcategories, selectedCategory, onCategoryChange }) => {
    const { i18n } = useTranslation();

    const getLocalizedCategory = (category) => {
        return i18n.language === 'ar' ? category.name_A : category.name_E;
    };

    const handleCategoryClick = (category) => {
        onCategoryChange(getLocalizedCategory(category));
    };

    return (
        <div className="flex items-center gap-[7px] flex-wrap mb-8">
            {subcategories.map(category => (
                <button
                    key={category.id}
                    className={`capitalize px-[30px] py-[7px] rounded-[4px] text-[14px] font-bold ${selectedCategory === getLocalizedCategory(category)
                        ? 'bg-[#017E89] text-white'
                        : 'bg-white text-[#017E89] shadow-md'
                        }`}
                    onClick={() => handleCategoryClick(category)}
                >
                    {getLocalizedCategory(category)}
                </button>
            ))}
        </div>
    );
};

const CosmeticProductCard = ({ product }) => {
    const { i18n } = useTranslation();
    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.ar : key.en;
    };

    return (
        <div className="w-full md:w-1/3 p-4">
            <div className="rounded-lg shadow-md overflow-hidden">
                <img
                    className="w-full h-64 object-cover"
                    src={product.image}
                    alt={getLocalizedText({ ar: product.name_ar, en: product.name_en })}
                />
                <div className="p-6">
                    <h3 className="text-xl font-bold text-[#017E89] mb-2">
                        {getLocalizedText({ ar: product.name_ar, en: product.name_en })}
                    </h3>
                    <p className="text-gray-600 mb-4">
                        {getLocalizedText({ ar: product.details_ar, en: product.details_en }).slice(0, 100)}...
                    </p>
                    <Link to={`/productsDetails/${product.id}`} className="flex items-center text-[#017E89] font-bold">
                        {i18n.language === 'ar' ? 'المزيد' : 'More Details'}
                        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default function Cosmetic() {
    const { t } = useTranslation();
    useScrollAnimation();

    const [subcategories, setSubcategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("Show All");

    useEffect(() => {
        // Fetch subcategories for Cosmetic category
        fetch('https://laravel-api.alnujoud-jo.com/api/subcategories')
            .then(response => response.json())
            .then(data => {
                const cosmeticSubs = data.data.filter(sub => sub.category_id === 9);
                setSubcategories([
                    { id: 'all', name_A: 'عرض الكل', name_E: 'Show All' },
                    ...cosmeticSubs
                ]);
            });

        // Fetch all products
        fetch('https://laravel-api.alnujoud-jo.com/api/products')
            .then(response => response.json())
            .then(data => {
                const cosmeticProducts = data.data.filter(p => p.category_id === 9);
                setProducts(cosmeticProducts);
            });
    }, []);

    const filterProducts = () => {
        if (selectedCategory === "Show All") return products;

        const selectedSub = subcategories.find(sub =>
            sub.name_E === selectedCategory || sub.name_A === selectedCategory
        );

        return products.filter(product =>
            product.sub_category_id === selectedSub?.id
        );
    };

    return (

        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">
                        {t("Products")}
                    </div>
                    <div className="btmAni2000 flex items-center gap-[5px] font-bold">
                        <Link to={'/'}>{t("Home")}</Link> -
                        <span className="text-[#017E89] capitalize">{t("Products")}</span>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <CosmeticCategoryFilter
                        subcategories={subcategories}
                        selectedCategory={selectedCategory}
                        onCategoryChange={setSelectedCategory}
                    />

                    <div className="flex flex-wrap gap-[10px]">
                        {filterProducts().map(product => (
                            <CosmeticProductCard key={product.id} product={product} />
                        ))}
                    </div>
                </div>
            </section >
        </>
    );
}